/**
 * Target guards for gesture start gating: resolve a gesture `EventTarget` to an
 * element and answer DOM predicates about it. Pure DOM helpers — no Solid, no
 * recognizer.
 */

import { isEditableElement } from "@/lib/dom/editable";

function asElement(target: EventTarget | null): Element | null {
  if (target instanceof Text) {
    return target.parentElement;
  }
  return target instanceof Element ? target : null;
}

/** True if `target` (or an ancestor) matches `selector`. */
export function closestSelector(target: EventTarget | null, selector: string): boolean {
  const el = asElement(target);
  return Boolean(el?.closest(selector));
}

/**
 * True if `target` itself is a form control / contenteditable. Used by the nav
 * drawer swipe: dragging inside a text field there selects/moves the cursor
 * instead of dismissing the drawer.
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  return isEditableElement(asElement(target));
}
